<template>
  <site-link
    :to="{ name: 'account.billing', hash: '#metered-billing' }"
    class="margin-right-md"
    @click.native="$posthog.capture(`usage:${actionEventName}`)"
  >
    <strong>{{ actionLabel }}</strong>
  </site-link>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'MeteredBillingAction',

    mixins: [EventTrackingMixin],

    props: {
      action: {
        type: String,
        default: 'enable'
      }
    },

    computed: {
      actionLabel() {
        return this.action === 'enable' ? 'Enable Metered Billing' : 'Metered Billing Settings'
      },

      actionEventName() {
        return this.action === 'enable' ? 'enable_metered_billing_link_click' : 'metered_billing_settings_link_click'
      }
    }
  }
</script>
